/* global google */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap } from 'react-google-maps';
import StationMarker from '../StationMarker';

const Map = withGoogleMap(({
  markers,
  onMapLoad,
  onMarkerShow,
  onMarkerHide,
  ...rest
}) => (
  <GoogleMap ref={onMapLoad} {...rest}>
    {markers.map(marker => (
      <StationMarker
        key={marker.key}
        station={marker.station}
        onShow={() => onMarkerShow(marker)}
        onHide={() => onMarkerHide(marker)}
        open={marker.showInfo}
      />
    ))}
  </GoogleMap>
));

const DEFAULT_ZOOM = 6;

export default function TrackerMap({
  markers,
  multiWindowsOpen,
  onMarkerShow,
  onMarkerHide,
  ...rest
}) {
  const [map, setMap] = useState();

  const fitToMarkers = useCallback(() => {
    if (!markers.length || !map) {
      return;
    }

    const bounds = new google.maps.LatLngBounds();

    markers.map(marker => (
      new google.maps.Marker({
        position: {
          lat: marker.station.latitude,
          lng: marker.station.longitude,
        },
        googleMap: map,
      })
    )).forEach((marker) => {
      bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);
  }, [markers, map]);

  // When markers are available, adjust map to fit to show all markers
  useEffect(() => {
    if (markers.length) {
      fitToMarkers();
    }
  }, [fitToMarkers, markers.length]);

  return (
    <Map
      containerElement={<div style={{ height: '100%' }} />}
      mapElement={<div style={{ height: '100%' }} />}
      zoom={DEFAULT_ZOOM}
      markers={markers}
      onMapLoad={setMap}
      onMarkerShow={onMarkerShow}
      onMarkerHide={onMarkerHide}
      {...rest}
    />
  );
}

TrackerMap.propTypes = {
  markers: PropTypes.arrayOf(PropTypes.shape()),
  multiWindowsOpen: PropTypes.bool,
  onMarkerShow: PropTypes.func,
  onMarkerHide: PropTypes.func,
};

TrackerMap.defaultProps = {
  markers: [],
  multiWindowsOpen: false,
  onMarkerShow: () => {},
  onMarkerHide: () => {},
};
